module.exports = __webpack_public_path__ + "static/media/DSCF9792-2.224ac172.jpg";